export enum BRANDS {
  BINGO = 'bingo',
  PRIZES = 'prizes',
  SPINS = 'spins',
}

export enum ItvCollectionType {
  PROMOTIONS = 'promotions',
  BINGO = 'bingo',
  GAMES = 'games',
}

export type AvailableBrands = 'bingo' | 'spins';
